export default __webpack_public_path__ + "b63b1a5.png";